// Shop catalog configuration — the KAI private-label brand + category mapping.
// Brand name lives in ONE place: change `name` here to switch every label on
// the site (e.g. to "VAE" if the trademark check objects to KAI).
export const BRAND = {
  name: "KAI",
  slug: "kai",
  tagline: "One word. Every essential.",
  vendor: "KAI", // must match the Vendor field set on products during Munazzo import
};

// Category chips on /shop. Matching is keyword-based over product_type + title +
// tags, so any product Munazzo syncs in lands in the right aisle automatically.
export const SHOP_CATEGORIES = [
  { id: "skincare", label: "Skincare & Beauty", blurb: "Creams, serums, masks — the daily ritual.",
    match: ["skin", "visage", "face", "crème", "cream", "serum", "sérum", "beauty", "beauté", "cosmetic", "lotion", "mask", "masque", "spf"] },
  { id: "hair", label: "Hair & Salon", blurb: "Shampoos, treatments and salon essentials.",
    match: ["shampoo", "conditioner", "après-shampoo", "hair", "cheveux", "salon", "coiff"] },
  { id: "personal-care", label: "Personal Care", blurb: "Soaps, shower, deodorants — everyday hygiene.",
    match: ["soap", "savon", "deodorant", "déodorant", "hygiene", "hygiène", "body", "corps", "shower", "douche", "toilet", "tooth", "dent"] },
  { id: "home-cleaning", label: "Home & Cleaning", blurb: "Laundry, surfaces and dish care.",
    match: ["clean", "nettoy", "detergent", "lessive", "household", "ménage", "surface", "dish", "vaisselle", "laundry"] },
  { id: "hotel", label: "Hotel & Hospitality", blurb: "Guest amenities and welcome kits.",
    match: ["hotel", "hôtel", "amenit", "guest", "hospitality", "accueil", "welcome"] },
  { id: "textiles", label: "Textiles & Apparel", blurb: "Towels, bathrobes, tees and totes.",
    match: ["towel", "serviette", "bathrobe", "peignoir", "textile", "gown", "scrub", "linen", "linge", "apparel", "t-shirt", "tee", "hoodie", "cap", "tote", "shirt"] },
  { id: "tableware", label: "Tableware & Food Service", blurb: "Plates, cups, bottles and packaging.",
    match: ["tableware", "plate", "assiette", "packaging", "emballage", "restaurant", "food service", "takeaway", "mug", "cup", "gobelet", "bottle", "bouteille", "gourde"] },
  { id: "stationery", label: "Stationery & Office", blurb: "Notebooks, posters and desk goods.",
    match: ["notebook", "carnet", "stationery", "papeterie", "poster", "pen ", "sticker", "desk", "bureau"] },
  { id: "baby", label: "Kids & Baby", blurb: "Gentle care for the little ones.",
    match: ["baby", "bébé", "kids", "enfant", "child"] },
];

export const OTHER_CATEGORY = { id: "other", label: "More", blurb: "Everything else." };

/** Which aisle does this product belong in? */
export function categorize(product) {
  const hay = `${product.product_type || ""} ${product.title || ""} ${(product.tags || []).join(" ")}`.toLowerCase();
  for (const c of SHOP_CATEGORIES) {
    if (c.match.some((k) => hay.includes(k))) return c.id;
  }
  return "other";
}

export function categoryById(id) {
  return SHOP_CATEGORIES.find((c) => c.id === id) || OTHER_CATEGORY;
}
